/**
 * The code is taken from here https://github.com/mvolkmann/styleable-select with some changes to fit our needs.
 * Use only on needed pages.
 */
function makeStyleableSelects() {
  function addClass(element, className) {
    if (element) {
      element.classList.add(className);
    }
  }

  function closeAllLists() {
    document.querySelectorAll('.styleable-select').forEach(function (stylebaleSelect) {
      closeList(stylebaleSelect);
    });
  }

  function closeList(select) {
    const list = select.querySelector('.styleable-select-list');
    list.style.display = 'none';
    removeClass(list, 'open');
    removeClass(select, 'open');

    const icon = select.querySelector('.styleable-select-current > i');
    icon.classList.remove('open');
    icon.style.zIndex = 0;
  }

  function different(s1, s2) {
    return s1 !== s2;
  }

  function findAncestorByClass(element, className) {
    while (element && !hasClass(element, className)) {
      element = element.parentNode;
    }
    return element;
  }

  function hasClass(element, className) {
    let classes = [];

    if (element.className instanceof SVGAnimatedString) {
      classes = element.className.baseVal.split(' ');
    } else {
      classes = element.className ? element.className.split(' ') : [];
    }

    for (let i = 0; i < classes.length; i++) {
      if (classes[i] === className) return true;
    }
    return false;
  }

  function removeClass(element, className) {
    if (!element) {
      return;
    }

    let classes = element.className.split(' ');
    classes = classes.filter(different);
    element.className = classes.join(' ');
    element.classList.remove(className);
  }

  function setValue(option, addSelectedClass = false) {
    const select = findAncestorByClass(option, 'styleable-select');
    const span = select.querySelector('.styleable-select-current > span');
    const newValue = option.textContent;
    span.textContent = newValue;
    select.value = option.getAttribute('value') || '';

    if (addSelectedClass) {
        const fieldSet = select.parentElement;
        if (fieldSet && !fieldSet.classList.contains('selected')) {
            fieldSet.classList.add('selected');
        }
    }

    let event = new Event('change', {'bubbles': true, 'cancelable': true});
    select.dispatchEvent(event);

    event = new Event('blur', {'bubbles': true, 'cancelable': true});
    select.dispatchEvent(event);
  }

  function toggleOpen(event) {
    event.preventDefault();

    const select = findAncestorByClass(event.target, 'styleable-select');
    const icon = select.querySelector('.styleable-select-current > i');
    const shouldNotBeOpenedLater = event.target === icon && hasClass(icon, 'open');

    closeAllLists();

    if (shouldNotBeOpenedLater) {
      return;
    }

    const fieldset = select.closest('fieldset');
    const span = select.querySelector('.styleable-select-current > span');
    const list = select.querySelector('.styleable-select-list');
    const shouldOpen = list.style.display !== 'block';

    if (shouldOpen) {
      if (fieldset) {
        list.style.width = fieldset.getBoundingClientRect().width + 'px';
      }

      // set big z-index for currently selected icon (will be set to 0 in closeList()).
      icon.style.zIndex = 9999;

      // Mark one of the options as the current one.
      const v = span.textContent;
      const options = list.querySelectorAll('.option');
      let found = false;

      for (let i = 0; i < options.length; i++) {
        const option = options.item(i);
        if (!found && option.textContent === v) {
          addClass(option, 'current');
          found = true;
        } else {
          removeClass(options[i], 'current');
        }
      }

      if (!found) addClass(options[0], 'current');

      addClass(list, 'open');
      addClass(select, 'open')
    } else {
      removeClass(list, 'open');
      removeClass(select, 'open');
    }

    list.style.display = shouldOpen ? 'block' : 'none';
    const iconClass = select.dataset.icon ? select.dataset.icon : 'chevron-down';
    icon.setAttribute('class', shouldOpen ? 'open fa-' + iconClass : 'fa-' + iconClass);
  }

  function cloneAttributes(element, sourceNode) {
    let attr;
    let attributes = Array.prototype.slice.call(sourceNode.attributes);
    while(attr = attributes.pop()) {
      element.setAttribute(attr.nodeName, attr.nodeValue);
    }
  }

  let option;

  const selects = document.querySelectorAll('select.styleable-select');
  for (let i = 0; i < selects.length; i++) {
    const select = selects.item(i);

    // Build the new element structure that will replace the select.
    const newSelect = document.createElement('div');

    // copy all attributes
    cloneAttributes(newSelect, select);

    const current = document.createElement('a');
    current.setAttribute('href', '#')
    addClass(current, 'unfocusable-click');

    addClass(current, 'styleable-select-current');
    const span = document.createElement('span');
    span.setAttribute('class', 'select-label')
    current.appendChild(span);

    const img = document.createElement('i');
    const iconClass = newSelect.dataset.icon ? newSelect.dataset.icon : 'chevron-down';
    img.setAttribute('class', 'fa-' + iconClass);
    current.appendChild(img);
    newSelect.appendChild(current);

    const list = document.createElement('div');
    addClass(list, 'styleable-select-list');

    const listInner = document.createElement('div');
    addClass(listInner, 'styleable-select-list-inner');
    list.appendChild(listInner);

    let value = select.getAttribute('value');
    if (value) value = value.trim();

    // Move option children from select to current.
    const options = select.querySelectorAll('option');
    let j;
    for (j = 0; j < options.length; j++) {
      option = options.item(j);
      if (value === option.getAttribute('value')) {
        span.textContent = option.textContent;
      }

      // if (option.getAttribute('value') === '') {
      //   option.setAttribute('value', '');
      // }

      const optionDiv = document.createElement('a');
      optionDiv.setAttribute('href', '#')
      optionDiv.textContent = option.textContent.trim();
      cloneAttributes(optionDiv, option);
      addClass(optionDiv, 'option');

      listInner.appendChild(optionDiv);
    }

    if (!value && options[0]) {
      span.textContent = options[0].textContent;
    }

    newSelect.appendChild(list);

    // Replace the select with the new structure.
    const parent = select.parentNode;
    parent.replaceChild(newSelect, select);

    addClass(newSelect, 'unfocusable-click');

    newSelect.onblur = function (event) {
      const select = findAncestorByClass(event.target, 'styleable-select');
      closeList(select);
    };

    // close all lists when user clicks outside the list
    document.body.onclick = function (event) {
      const select = findAncestorByClass(event.target, 'styleable-select');

      if(!select) {
        closeAllLists();
      }
    };

    newSelect.onkeydown = function (event) {
      const select = findAncestorByClass(event.target, 'styleable-select');
      const list = select.querySelector('.styleable-select-list');

      // Find index of current option.
      const options = list.querySelectorAll('.option');
      let index = 0;
      let option;
      for (; index < options.length; index++) {
        option = options[index];
        if (hasClass(option, 'current')) break;
      }

      const isEnter = event.code === 'Enter';
      const isSpace = event.code === 'Space';
      const isEsc = event.code === 'Escape';
      const isDown = event.code === 'ArrowDown';
      const isUp = event.code === 'ArrowUp';
      const isExpectedKey = isEnter || isDown || isUp;
      const nothingSelected = index === options.length;

      if ((isEnter || isSpace) && hasClass(list, 'open')) {
        setValue(option);
      } else if (isSpace) {
        toggleOpen(event);
      } else if (nothingSelected && isExpectedKey) {
        addClass(options[0], 'current');
        toggleOpen(event);
      } else if (!hasClass(list, 'open')) {
        if (isExpectedKey) {
          addClass(list, 'open');
          list.style.display = 'block';
        }
      } else if (isEsc) {
        closeList(select);
      } else if (isUp) {
        if (index === 0) return;
        removeClass(options[index], 'current');
        addClass(options[index - 1], 'current');
      } else if (isDown) {
        if (index === options.length - 1) return;
        removeClass(options[index], 'current');
        addClass(options[index + 1], 'current');
      }
    };

    current.onclick = toggleOpen;

    const newOptions = list.querySelectorAll('.option');

    for (j = 0; j < newOptions.length; j++) {
      option = newOptions.item(j);

      if (hasClass(option, 'current')) {
        setValue(option);
      }

      option.onclick = function (event) {
        event.preventDefault();
        setValue(this, event.isTrusted);
      };
    }
  }
}

makeStyleableSelects();

export default makeStyleableSelects;
